konnyScript(function($){
  
    /* 컬러슬라이드 탭 기능_여닫기 X */
    $('.c_btnbox li').click(function(){
        var bgBox = $(this).parents('.c_btnbox');
        bgBox = bgBox.siblings('.c_bgbox');

        var index = $(this).index();
        $(this).addClass('on').siblings().removeClass('on');
        bgBox.children().removeClass('on').eq(index).addClass('on');
    });
  
    $('.flex_qnaBox .qnaTop').click(function(){
        var onDiv = $(this).parents('.flex_qnaBox');
        onDiv.toggleClass('on');
    });

    $('.kntgBtn').click(function(){
        var tapDiv = $(this).parents('.kntgWrap');
        tapDiv.toggleClass('on');
    });
});
